import { Dependency } from './dependency.model';

export class ShowcaseDependency {
  dependency: Dependency;
}
